import { Store } from './store/gameStore';

export function showPopup(popupId: string) {
    Store.shownPopup(popupId);
    dispatchEvent(new CustomEvent('open-popup', { detail: popupId }));
}
